import { AnimatePresence } from 'framer-motion';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { PPRouterProps } from '../../routes/paths';
import { GlobalState } from '../../store/reducers';
import { getPrescription } from '../../store/selectors/prescriptionPad';
import { getEditPatient, getEditPtMH } from '../../store/selectors/session';
import { Patient } from '../../store/types/patient';
import { Prescription } from '../../store/types/prescription';
import EditPatientDetailsDialog from './EditPatientDetailsDialog';
import { setEditPatient } from '../../store/actions/session';
import { MHC } from '../../store/types/medicalHistory';
import { isSingleDoctorAccess, getSingleDoctor } from '../../store/idbHandler';
const EP: React.FC<{
    prescription?: Prescription;
    onComplete?: (patient: Patient) => void;
    patientHistory: MHC | undefined;
    fetchMH?: () => void;
}> = ({ prescription, onComplete, patientHistory, fetchMH }) => {
    const dispatch = useDispatch();
    const editPatient = useSelector(getEditPatient);
    const ptMH = prescription?.patientHistory ?? patientHistory;

    const params: PPRouterProps = useParams();

    if (params?.pxState === 'finish') {
        return null;
    }

    const closeMe = () => {
        dispatch(setEditPatient());
    };

    return (
        <AnimatePresence>
            {editPatient && (
            <EditPatientDetailsDialog
                    editPatient={editPatient}
                    onComplete={(p) => {
                        onComplete && onComplete(p);
                        fetchMH && fetchMH();
                    }}
                    closeMe={closeMe}
                    pxId={
                        prescription?.id && window.location.pathname.includes(prescription?.id)
                            ? prescription?.id
                            : undefined
                    }
                    //TODO: move this to business id
                    docid={isSingleDoctorAccess() ? getSingleDoctor()?._id : undefined}
                    ptMedicalHistory={ptMH}
                />
            )}
        </AnimatePresence>
    );
};

export const EditPatientWrapperDialog = connect((state: GlobalState) => ({
    prescription: getPrescription(state),
    patientHistory: getEditPtMH(state),
}))(EP);
